// removed by extract-text-webpack-plugin
module.exports = {"menu":"menu-2jsjQ","link":"link-2qjVs"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/index/style.scss
 ** module id = 107
 ** module chunks = 0
 **/